module.exports = __webpack_public_path__ + "media/images/favicon/favicon@apple-touch-icon-e4dfa0a066c77c058ed80cad6f6a4b78.png";